import React, { Component } from 'react'
import { XCircleIcon, LockClosedIcon, EyeIcon } from '@heroicons/react/solid'
import ButtonPrevious from '../UI/ButtonPrevious'

class SubscribeStepAccountSetup extends Component {
	constructor(props) {
		super(props)
		this.state = {
			password: '',
			visible: false,
			confirmation: false,
			error: null,
			loading: false
		}
	}

	handleSubmit = (event) => {
		event.preventDefault()
		if (this.state.password.length < 8) {
			this.setState({ error: "Le mot de passe doit contenir au moins 8 caractères." })
			return
		}
		if (/[a-zA-Z]/.test(this.state.password) === false) {
			this.setState({ error: "Le mot de passe doit contenir au moins une lettre." })
			return
		}
		if (!this.state.confirmation) {
			this.setState({ error: "Vous devez accepter la politique de confidentialité." })
			return
		}
		this.setState({ loading: true, error: null })
		this.props.onSubmit({ password: this.state.password })
		.catch(errorMsg => {
			this.setState({ loading: false, error: errorMsg || "Une erreur s'est produite." })
		})
	}

	handleVisible = () => {
		this.setState({ visible: !this.state.visible })
	}

	render() {
		const themeColor = '#' + this.props.theme.color1
		const isValid = this.state.password.length >= 8 && /[a-zA-Z]/.test(this.state.password) && this.state.confirmation
		const btnColor = isValid ? themeColor : '#A3A3A3'
		const inputType = this.state.visible ? 'text' : 'password'

		return (
			<div>
				<ButtonPrevious
					theme={this.props.theme}
					handlePreviousBtn={this.props.handlePreviousBtn}
				/>
				<div style={{ backgroundColor: themeColor }} className="h-52 z-0 px-8 text-center">
					<p className="text-2xl text-white pt-14 mt-0">Dernière étape</p>
					<h1 className="text-3xl text-white font-semibold m-0 pt-2">Finalisez votre compte</h1>
				</div>
				<div className="rounded-t-3xl z-10" style={{ backgroundColor: "#ffffff", marginTop: "-2rem" }}>
					<div className="px-10 pt-12 pb-10">

						{/* Message de bienvenue */}
						{this.props.user.firstname && (
							<div className="mb-8">
								<p className="text-xl font-semibold text-gray-800">
									Bienvenue, {this.props.user.firstname} !
								</p>
								{this.props.user.checkin && this.props.user.checkout && (
									<p className="text-sm text-gray-500 mt-1">
										Votre séjour du {this.props.user.checkin} au {this.props.user.checkout} a bien été retrouvé.
									</p>
								)}
							</div>
						)}

						<form onSubmit={this.handleSubmit}>

							{/* Email — lecture seule */}
							<div className="mb-8">
								<label className="block text-sm font-medium text-gray-500 mb-1">Email</label>
								<div className="flex items-center border-b border-gray-200 py-1">
									<span className="flex-1 text-gray-400 text-xl">{this.props.user.email}</span>
									<LockClosedIcon className="h-4 w-4 text-gray-300 flex-shrink-0" />
								</div>
							</div>

							{/* Mot de passe */}
							<div className="mb-8">
								<label className="block text-sm font-medium text-gray-500 mb-1">Mot de passe</label>
								<div className="flex justify-between border-b border-gray-300 focus-within:border-blue-500">
									<input
										className="block pl-0 w-full border-0 border-transparent text-gray-700 focus:ring-0 text-xl"
										type={inputType}
										value={this.state.password}
										onChange={(e) => this.setState({ password: e.target.value, error: null })}
										autoComplete="new-password"
									/>
									<button
										type="button"
										className="-ml-px relative inline-flex px-4 py-2 text-sm font-medium text-gray-700"
										onClick={this.handleVisible}
									>
										<EyeIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
									</button>
								</div>
								<p className="text-xs text-gray-400 mt-1">8 caractères minimum, dont au moins une lettre</p>
							</div>

							{/* CGU */}
							<div className="rounded-md bg-green-50 p-4 mb-6">
								<div className="flex items-center">
									<input
										type="checkbox"
										checked={this.state.confirmation}
										onChange={() => this.setState({ confirmation: !this.state.confirmation, error: null })}
										className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded"
									/>
									<label className="ml-2 block text-sm text-gray-900">
										Je déclare avoir lu et accepté la <a className="font-semibold underline" href="https://www.pocketcamp.fr/politique-confidentialite">politique de protection des données</a>.
									</label>
								</div>
							</div>

							{this.state.error && (
								<div className="rounded-md bg-red-50 p-4 mb-4">
									<div className="flex">
										<div className="flex-shrink-0">
											<XCircleIcon className="h-5 w-5 text-red-400" aria-hidden="true" />
										</div>
										<div className="ml-3">
											<h3 className="text-sm font-medium text-red-800">{this.state.error}</h3>
										</div>
									</div>
								</div>
							)}

							<button
								className="items-center px-6 py-5 border border-transparent text-xl font-medium rounded-full w-full shadow-sm text-white"
								type="submit"
								disabled={this.state.loading || !isValid}
								style={{ backgroundColor: btnColor }}
							>
								{this.state.loading ? 'Création du compte...' : 'Créer mon compte'}
							</button>
						</form>
					</div>
				</div>
			</div>
		)
	}
}

export default SubscribeStepAccountSetup
